/**
 * Analytics tracker for OTP module
 * Matches iOS OTPTracker.swift exactly
 */

import AnalyticsManager from '../AnalyticsManager'
import { ScreenName, ButtonName, ButtonLocation } from '../ScreenName'
import { AnalyticsEvent } from '../AnalyticsEvents'

/**
 * Protocol/interface for OTPTracker
 * Matches iOS OTPTrackerProtocol
 */
export interface OTPTrackerProtocol {
  trackOpenScreen(): void
  trackValidationError(endPoint: string, error: string): void
  trackSubmitOtpButton(): void
  trackLoginStarted(): void
  trackLoginSuccess(): void
  trackLoginFail(error: string): void
}

/**
 * OTP tracker implementation
 */
class OTPTracker implements OTPTrackerProtocol {
  private analyticsManager: AnalyticsManager

  constructor(analyticsManager: AnalyticsManager = AnalyticsManager.shared) {
    this.analyticsManager = analyticsManager
  }

  trackOpenScreen(): void {
    // iOS OTPTracker uses .login screen name, not .otp
    this.analyticsManager.trackScreenView(ScreenName.LOGIN)
  }

  trackValidationError(endPoint: string, error: string): void {
    // iOS OTPTracker uses .otp screen name for validation errors
    this.analyticsManager.trackValidationError(ScreenName.OTP, undefined, error, {
      api_endpoint: endPoint,
    })
  }

  trackSubmitOtpButton(): void {
    this.analyticsManager.trackButtonClick(ButtonName.SUBMIT_OTP, ButtonLocation.PRIMARY, ScreenName.OTP)
  }

  trackLoginStarted(): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.LOGIN_STARTED, ScreenName.OTP, {})
  }

  trackLoginSuccess(): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.LOGIN_SUCCESS, ScreenName.OTP, {})
  }

  trackLoginFail(error: string): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.LOGIN_FAIL, ScreenName.OTP, {
      error_message: error,
    })
  }
}

export default OTPTracker

